import _createClass from '@babel/runtime/helpers/createClass';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { removeKeysFromObj } from './object.js';

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function createLocalStorageManager(storageKey) {
  return new StorageManager(localStorage, storageKey);
}
function createSessionStorageManager(storageKey) {
  return new StorageManager(sessionStorage, storageKey);
}
var StorageManager = /*#__PURE__*/_createClass(
// use '.' only to distinct version

function StorageManager(storage, storageKey) {
  var _this = this;
  _classCallCheck(this, StorageManager);
  _defineProperty(this, "LOCAL_STORAGE_KEY", void 0);
  _defineProperty(this, "versionDelimiter", '.');
  _defineProperty(this, "storage", void 0);
  _defineProperty(this, "storageType", void 0);
  _defineProperty(this, "getFromStorage", function (unitName) {
    try {
      var qodanaStoreStr = _this.storage.getItem(_this.LOCAL_STORAGE_KEY);
      if (qodanaStoreStr === null) {
        return null;
      }
      var qodanaStore = JSON.parse(qodanaStoreStr);
      return qodanaStore[unitName];
    } catch (e) {
      console.error("getFromStorage, can't get data from ".concat(_this.storageType, " storage: "), e.message);
      return null;
    }
  });
  _defineProperty(this, "saveToStorage", function (unitName, data) {
    try {
      var qodanaStoreStr = _this.storage.getItem(_this.LOCAL_STORAGE_KEY);
      var qodanaStore = qodanaStoreStr !== null ? JSON.parse(qodanaStoreStr) : {};
      var unitOlderKeys = _this.generateOlderKeys(unitName);
      var clearedStore = removeKeysFromObj(qodanaStore, unitOlderKeys);
      clearedStore[unitName] = data;
      _this.storage.setItem(_this.LOCAL_STORAGE_KEY, JSON.stringify(clearedStore));
      return true;
    } catch (e) {
      console.error("saveToStorage, can't save data to ".concat(_this.storageType, " storage: "), e.message);
      return false;
    }
  });
  _defineProperty(this, "removeUnitFromStorage", function (unitName) {
    try {
      var qodanaStoreStr = _this.storage.getItem(_this.LOCAL_STORAGE_KEY);
      var qodanaStore = qodanaStoreStr !== null ? JSON.parse(qodanaStoreStr) : {};
      var newStore = {};
      for (var _i = 0, _Object$keys = Object.keys(qodanaStore); _i < _Object$keys.length; _i++) {
        var unit = _Object$keys[_i];
        if (unit !== unitName) {
          newStore[unit] = qodanaStore[unit];
        }
      }
      _this.storage.setItem(_this.LOCAL_STORAGE_KEY, JSON.stringify(newStore));
    } catch (e) {
      console.error("removeUnitFromStorage, can't remove data from ".concat(_this.storageType, " storage: "), e.message);
    }
  });
  _defineProperty(this, "cleanObsoleteStorage", function () {
    try {
      var qdOlderKeys = _this.generateOlderKeys(_this.LOCAL_STORAGE_KEY);
      var _iterator = _createForOfIteratorHelper(qdOlderKeys),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var oldKey = _step.value;
          _this.storage.removeItem(oldKey);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } catch (e) {
      console.error("cleanObsoleteStorage, can't remove obsolete data from ".concat(_this.storageType, " storage: "), e.message);
    }
  });
  _defineProperty(this, "generateOlderKeys", function (versionedStr) {
    var _split$find;
    var result = [];
    var split = versionedStr.split(_this.versionDelimiter);
    var version = Number((_split$find = split.find(function (el) {
      return el[0] === 'v' && isFinite(Number(el.slice(1)));
    })) === null || _split$find === void 0 ? void 0 : _split$find.slice(1));
    for (var i = 1; i < version; i++) {
      if (versionedStr.indexOf(".v".concat(version, ".")) !== -1) {
        result.push(versionedStr.replace(".v".concat(version, "."), ".v".concat(i, ".")));
      }
    }
    return result;
  });
  this.LOCAL_STORAGE_KEY = storageKey;
  this.storage = storage;
  this.storageType = storage === localStorage ? 'local' : 'session';
});

export { StorageManager, createLocalStorageManager, createSessionStorageManager };
